<div *ngIf="currentContact">
  <div class="person-desc">
    <app-person-container [vorname]="currentContact.vorname"
                          [name]="currentContact.nachname"
                          [subText]="[currentContact.abteilung, currentContact.stelle]"
                          [titelPre]="currentContact.titelPre"
                          [titelPost]="currentContact.titelPost"
                          [imageURL]="staticPath.getPersonImgPath()+currentContact.image"></app-person-container>
  </div>
  <div class="item-container">
    <div *appHasRightId="benutzerStatusRight" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <ng-container *ngIf="!currentBenutzerStatusLoading">
          <div class="material-icons pointer-cursor status-color kontakt-status"
               [ngClass]="{'status1': currentBenutzerStatus.status === '1',
                 'status2': currentBenutzerStatus.status === '2',
                 'status3': currentBenutzerStatus.status === '3',
                 'status4': currentBenutzerStatus.status === '4',
                 'status5': currentBenutzerStatus.status === '5',
                 'status6': currentBenutzerStatus.status === '6'}"
          >fiber_manual_record
          </div>
          {{currentBenutzerStatus.message ? currentBenutzerStatus.message : getAnwenwesenheitStr(currentBenutzerStatus)}}
        </ng-container>
        <div class="loader-container" *ngIf="currentBenutzerStatusLoading">
          <app-loader [dotted]="true"></app-loader>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="currentContact.kundenbuero" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <mat-icon class="kontakt-action">home</mat-icon>
        KB {{currentContact.kundenbuero}}
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="currentContact.zimmerNr" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <mat-icon class="kontakt-action">meeting_room</mat-icon>
        Zimmer Nr. {{currentContact.zimmerNr}}
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="currentContact.mobil" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <mat-icon class="kontakt-action" (click)="openTel(currentContact.mobil)">smartphone</mat-icon>
        {{currentContact.mobil}}
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="currentContact.email" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <mat-icon class="kontakt-action" (click)="openMail(currentContact.email)">mail</mat-icon>
        {{currentContact.email}}
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="currentContact.fest" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <mat-icon class="kontakt-action" (click)="openTel(currentContact.fest)">phone</mat-icon>
        {{currentContact.fest}}
      </div>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="currentContact.kostenstelle" class="kontakt-item">
      <div textSmall class="kontakt-entry">
        <mat-icon class="kontakt-action">commit</mat-icon>
        {{ currentContact.kostenstelle }}
      </div>
      <mat-divider></mat-divider>
    </div>
  </div>
  <ng-container *ngIf="showRelated">
    <div class="list-select-container">
      <pezi-button
              (click)="currentDisplayedListIndex = 0" [isOutlined]="currentDisplayedListIndex !== 0" text="Vorgesetzte(r)" [isSmallButton]="true"></pezi-button>
      <pezi-button
                    (click)="currentDisplayedListIndex = 1" [isOutlined]="currentDisplayedListIndex !== 1" text="Kollegen" [isSmallButton]="true"></pezi-button>
      <pezi-button
                    (click)="currentDisplayedListIndex = 2" [isOutlined]="currentDisplayedListIndex !== 2" text="Mitarbeiter" [isSmallButton]="true"></pezi-button>
    </div>
    <div *ngIf="currentDisplayedListIndex===0">
      <app-list *ngIf="!vorgesetzterLoading" nodataIcon="supervised_user_circle"
                [entries]=" vorgesetzter ? [vorgesetzter] : null" [withShadow]="false"
                (listEntryClick)="onContactSelect($event)"></app-list>
      <app-loader *ngIf="vorgesetzterLoading"></app-loader>
    </div>
    <div *ngIf="currentDisplayedListIndex===1">
      <div class="ma-containter" *ngIf="!kollegenLoading">
        <app-list nodataIcon="supervised_user_circle" [entries]="kollegen" [withShadow]="false"
                  (listEntryClick)="onContactSelect($event)"></app-list>
      </div>
      <app-loader *ngIf="kollegenLoading"></app-loader>
    </div>
    <div *ngIf="currentDisplayedListIndex===2">
      <div class="ma-containter" *ngIf="!mitarbeiterLoading">
        <app-list nodataIcon="supervised_user_circle" [entries]="mitarbeiter"
                  [withShadow]="false"
                  (listEntryClick)="onContactSelect($event)"></app-list>
      </div>
      <app-loader *ngIf="mitarbeiterLoading"></app-loader>
    </div>
  </ng-container>
</div>
